import type { accountType_enum } from '@vrplatform/graphql';

const titles: Record<accountType_enum, string> = {
  bank: 'Bank',
  ledger: 'Ledger',
  recurringFee: 'Fees & Commissions',
  nonPosting: 'Reference',
};

export const formatAccountType = (type: accountType_enum) => {
  return titles[type];
};
